import { render, staticRenderFns } from "./PageEditorSiteTreePinBtn.vue?vue&type=template&id=12e38331&scoped=true"
import script from "./PageEditorSiteTreePinBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorSiteTreePinBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e38331",
  null
  
)

export default component.exports